window.dtPresenceMachine = function () {
  const dt_presence_machine = new DataTable('#presence-machine-datatable', {
    processing: false,
    serverSide: true,
    responsive: true,
    ajax: {
      url: $('#presence-machine-datatable').data('source'),
      beforeSend: function () { showLoadingRow('#presence-machine-datatable', 7); },
      complete: function () { hideLoadingRow(); }
    },
    pagingType: "full_numbers",
    order: [[1, 'desc'], [2, 'asc']],
    columns: [
      { "data": "index" },
      { "data": "status" },
      { "data": "code" },
      { "data": "name" },
      { "data": "kind" },
      { "data": "ip_address" },
      { "data": "last_sync" },
    ],
    columnDefs: [
    ],
    language: {
      search: ' ',
      sLengthMenu: '_MENU_',
      searchPlaceholder: "Search...",
      info: "Showing _START_ to _END_ of _TOTAL_ entries"
    },
    rowCallback: function (row, data, index) {
      $('td', row).addClass('py-1');
    },
  });

  dtFinalTouch()
}

 
